import {
  Col,
  Form,
  Input,
  notification,
  Popconfirm,
  Row,
  Tag,
  Typography,
} from 'antd';
import ButtonOperation from 'components/ButtonOperation';
import DataGrid, { DataGridColDef } from 'components/DataGrid/DataGrid';
import DeleteButton from 'components/DeleteButton';
import ParListSelect from 'components/ParListSelect';
import DF from 'DisplayFramework';
import { isEqual } from 'lodash';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { SwapOutlined } from '@ant-design/icons';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import {
  getParMarketingByCriteria,
  GetParMarketingByCriteriaParams,
  ParMarketingResponse,
  RemoveParMarketing,
  UpdateParMarketingStatus,
} from 'services/assetconfig';
import ProductInput from 'pages/ProposalV3/PropDetail/ProductInput';
import { indexBy } from 'utils/utils2';
import RouterLink from 'components/RouterLink';
import NewButton from 'components/NewButton';
import ThirdPartyInput from 'components/ThirdPartyInput';

type Values = {
  marketingCompaign: ParMarketingResponse[];
};
const initialSearchParams: GetParMarketingByCriteriaParams = {
  mccode: '',
  mcid: '' as any,
  mclabel: '',
  mcstatus: '',
  networkcode: '',
  prcode: '',
  tpidmanufacturer: '' as any,
  tpidbroker: '' as any,
};
export type McInputProps = {
  onSelect: (mcomp: ParMarketingResponse) => void;
  initialSearchParams: Partial<GetParMarketingByCriteriaParams>;
};

const MarketingCompaign = (props: McInputProps) => {
  const { onSelect } = props;
  const [form] = Form.useForm();
  const fieldName = 'marketingCompaign';
  const history = useHistory();

  const [searchs, setsearchs] = useState(false);

  const value = initialSearchParams;

  const [searchParams, setSearchParams] =
    useState<GetParMarketingByCriteriaParams>({
      ...initialSearchParams,

      // ...value,
      // ...props.initialSearchParams,
    });

  const { data, refetch, isFetching } = useQuery(
    ['getParMarketingByCriteria', searchParams],
    () => getParMarketingByCriteria(searchParams).then((res) => res.list || []),
    { enabled: searchs }
  );

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        [fieldName]: data,
      });
    }
  }, [form, data]);

  const getName = useCallback(
    (name: string) => (record: ParMarketingResponse) => {
      const functions = form.getFieldValue(fieldName);
      const index = indexBy(functions, 'mcid')[record.mcid];

      return [fieldName, index, name];
    },
    [form]
  );

  const columns = useMemo<DataGridColDef<ParMarketingResponse>[]>(
    () => [
      {
        dataIndex: 'mcid',
        filtrable: 'mcid',
        width: 100,
        render: (value, record) => {
          return <Form.Item name={getName('mcid')(record)}>{value}</Form.Item>;
        },
      },
      {
        dataIndex: 'mclabel',
        filtrable: true,
        render: (value, record) =>
          onSelect ? (
            <Typography.Link
              onClick={() => {
                onSelect(record);
              }}
            >
              {value}
            </Typography.Link>
          ) : (
            <RouterLink to={`/configuration/marketingCompaign/${record.mcid}`}>
              {value}
            </RouterLink>
          ),
        width: 190,
      },
      {
        dataIndex: 'mccode',
        filtrable: 'mccode',
        filterComponent: <Input />,
        width: 140,
      },
      {
        comcode: 'networkcode',
        dataIndex: 'networklabel',
        filtrable: 'networkcode',
        filterComponent: <ParListSelect parcode="NETWORK" />,
        width: 200,
      },
      {
        comcode: 'prcode',
        dataIndex: 'prcodelabel',
        filtrable: 'prcode',
        filterComponent: <ProductInput />,
        render: (value, record) => record.prlabel,
      },
      {
        dataIndex: 'tpidmanufacturer',
        filtrable: 'tpidmanufacturer',
        filterComponent: <ThirdPartyInput role="OEM" onlytpid />,
        render: (value, record) => {
          return record.manufacturername;
        },
        width: 200,
      },
      {
        dataIndex: 'brokername',
        filtrable: 'tpidbroker',
        filterComponent: <ThirdPartyInput role="BROKER" onlytpid />,
        render: (value, record) => {
          return record.brokername;
        },
        width: 200,
      },
      {
        dataIndex: 'startdate',
        render: (value, record) => value,
      },
      {
        dataIndex: 'enddate',
        render: (value, record) => value,
      },
      {
        dataIndex: 'mcstatus',
        filtrable: 'mcstatus',
        filterComponent: <ParListSelect parcode="PRSTATUS" allowClear />,
        render: (value, record) => (
          <Tag
            color={
              record.mcstatus === 'ACTIVE'
                ? 'success'
                : record.mcstatus === 'DISABLED'
                ? 'error'
                : record.mcstatus === 'END'
                ? 'blue'
                : 'default'
            }
          >
            {value}
          </Tag>
        ),
      },
      {
        key: 'Actions',
        fixed: 'right',
        render: (_, record) => (
          <Row>
            <Col span={16}>
              {record.mcstatus === 'INIT' && (
                <ButtonOperation
                  size="large"
                  comcode="Activate"
                  icon={<SwapOutlined />}
                  onClick={() => {
                    UpdateParMarketingStatus({
                      mcid: record.mcid,
                      mcstatus: 'ACTIVE',
                    }).then((response) => {
                      refetch();
                      notification.success({
                        message: response.message,
                      });
                    });
                  }}
                />
              )}
              {record.mcstatus === 'ACTIVE' && (
                <ButtonOperation
                  size="large"
                  comcode="Disabled"
                  icon={<SwapOutlined />}
                  onClick={() => {
                    UpdateParMarketingStatus({
                      mcid: record.mcid,
                      mcstatus: 'DISABLED',
                    }).then((response) => {
                      refetch();
                      notification.success({
                        message: response.message,
                      });
                    });
                  }}
                />
              )}

              {record.mcstatus === 'DISABLED' && (
                <ButtonOperation
                  size="large"
                  comcode="Terminate"
                  icon={<SwapOutlined />}
                  onClick={() => {
                    UpdateParMarketingStatus({
                      mcid: record.mcid,
                      mcstatus: 'END',
                    }).then((response) => {
                      refetch();
                      notification.success({
                        message: response.message,
                      });
                    });
                  }}
                />
              )}

              {record.mcstatus === 'END' && (
                <ButtonOperation
                  size="large"
                  comcode="Activate"
                  icon={<SwapOutlined />}
                  onClick={() => {
                    UpdateParMarketingStatus({
                      mcid: record.mcid,
                      mcstatus: 'ACTIVE',
                    }).then((response) => {
                      refetch();
                      notification.success({
                        message: response.message,
                      });
                    });
                  }}
                />
              )}
            </Col>
            <Col span={8}>
              {record.mcstatus === 'INIT' && (
                <Popconfirm
                  title="Are you sure to delete this action?"
                  onConfirm={() => {
                    RemoveParMarketing({
                      mcid: record.mcid,
                    }).then(() => refetch());
                  }}
                  okText="Yes"
                  cancelText="No"
                >
                  <DeleteButton onlyIcon />
                </Popconfirm>
              )}
            </Col>
          </Row>
        ),
        width: 210,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [form, history, refetch]
  );

  return (
    <DF.Provider pagcode="marketinglist">
      <Form form={form}>
        <Form.Item
          noStyle
          shouldUpdate={(prevValue: Values, nextValue: Values) => {
            return !isEqual(prevValue, nextValue);
          }}
        >
          {({ getFieldValue }) => {
            const marketingCompaign: ParMarketingResponse[] =
              getFieldValue(fieldName);

            return (
              <DataGrid
                rowKey="mcid"
                columns={columns}
                isLoading={isFetching}
                dataSource={marketingCompaign}
                componentName="marketing_list"
                titleComcode="marketingCompaignList"
                onSearch={(values) => {
                  setsearchs(true);
                  setSearchParams(values);
                }}
                initialSearchValues={initialSearchParams}
                extraActions={
                  <NewButton
                    comcode="add"
                    onClick={() =>
                      history.push('/configuration/marketingCompaign/create')
                    }
                  />
                }
              />
            );
          }}
        </Form.Item>
      </Form>
    </DF.Provider>
  );
};

export default MarketingCompaign;
